module.exports = __webpack_public_path__ + "img/smg.7b0f66d0.svg";